import { render } from "./interests-list.component.vue?vue&type=template&id=76ece0c8&ts=true"
import script from "./interests-list.component.vue?vue&type=script&lang=ts"
export * from "./interests-list.component.vue?vue&type=script&lang=ts"

import "./interests-list.component.vue?vue&type=style&index=0&id=76ece0c8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__